export class ContentNode {
  public directory: boolean
  public path: string
}
